export function* chunks<T>(items: T[], itemsToDisplay: number) {
  for (let i = 0; i <= items.length - 1; i++) {
    const endIdx = i + itemsToDisplay;

    yield endIdx < items.length ?
      items.slice(i, i + itemsToDisplay) :
      [...items.slice(i, i + itemsToDisplay), ...items.slice(0, endIdx - items.length)];
  }
}